<savvas-shared-ui-line-area-chart
  tabindex="0"
  role="group"
  [lineChartItems]="growthMetricScoreGraph?.lineChartItems"
  [xAxisConfigs]="growthMetricScoreGraph?.xAxisConfigs"
  [yAxisConfigs]="growthMetricScoreGraph?.yAxisConfigs"
  [yAxisRange]="growthMetricScoreGraph?.yAxisRange"
  [tooltipConfigs]="growthMetricScoreGraph?.toolTipConfigs"
  [chartMargin]="growthMetricScoreGraph?.chartMargin"
  [chartStyleConfigs]="growthMetricScoreGraph?.chartStyleConfigs"
></savvas-shared-ui-line-area-chart>
